<label class={['label', $$restProps.class].join(' ')}><slot /></label>

<style>.label {
  color: #212529;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
}</style>
